import { ElementType, ReactNode } from "react";
import { DropdownProps } from "react-bootstrap/Dropdown";
import { ButtonVariant } from "react-bootstrap/types";

export type DropdownButtonVariant =
  | "menu-primary"
  | "menu-secondary"
  | ButtonVariant;
export interface DropdownContainerProps extends DropdownProps {
  name: string;
  disabled?: boolean;
  className?: string;
  buttonVariant?: DropdownButtonVariant;
  buttonLabel: string | ReactNode;
  buttonIcon?: string;
  buttonClassName?: string;
  showDropdownIcon?: boolean;
  children: ReactNode;
  buttonSize?: "sm" | "lg" | "md";
  buttonComponent?: ElementType;
  limitMenuHeight?: boolean;
  menuItemDisplay?: {
    compact?: boolean;
    indented?: boolean;
  };
  labelWidthLimit?: string;
}

export interface DropdownWithSectionsProps
  extends Omit<DropdownContainerProps, "children"> {
  sections: {
    title: string;
    items: {
      label: string;
      value: string;
    }[];
  }[];
  hideEmptySections?: boolean;
  emptySectionMessage?: string;
  compactMenuItemDisplay?: boolean;
  widthVariant?: "sm" | "md" | "lg" | "full" | undefined;
}
